export default "__VITE_ASSET__a2505f0b__"